<template>
<div>

	<div v-for="(field,fieldIndex) in localFormFields" class="company-form-field" :class="{error: 'hasError' in field && field.hasError}">

		<weather-widget v-if="field.type == 'weather'"
			:show-warnings="true"
			:lat="job && 'lat' in job ? job.lat : null"
			:lon="job && 'long' in job ? job.long : null"
			v-on:weatherFetched="weatherFetched($event,fieldIndex)">
		</weather-widget>

		<div v-else-if="['select', 'personnel-phone-list'].includes(field.type) && 'defineOther' in field && field.defineOther">

			<div v-if="field.value == 'Other' || (!field.options || !field.options.find(opt => field.value == opt) && field.value !== '')">

				<field
					:label="field.label" col-class="col-md-6"
					:params="{type:'text'}"
					:readonly="readonly"
					v-model="field.value"
					v-on:change="emitFields">
					<a href="#" v-on:click.prevent="field.value = '';emitFields()">Reset selection</a>
				</field>
			</div>

			<field v-else
				:label="field.label" col-class="col-md-6"
				:params="setFieldParams(field)"
				:readonly="readonly"
				v-on:change="emitFields"
				v-model="field.value">
			</field>
		</div>

		<div v-else-if="field.type == 'image'">

			<form-group :label="field.label"
				:col-class="'imageIsStatic' in field && field.imageIsStatic ? 'stacked' : 'col-md-6'">

				<img v-if="!isChildTemplate && 'imageIsStatic' in field && field.imageIsStatic" :src="field.value && field.value.length > 0 ? getMainSrc(field.value[0]) : ''" style="display: block;margin: auto;max-width: 100%;">

				<template v-else-if="typeof field.value == 'object'">

					<image-panel v-for="(image, index) in field.value"
						v-if="image"
						:readonly="readonly"
						:no-edit="!image || !('meta' in image && image.meta.isNew)"
						:no-rotate="!image || !('meta' in image && image.meta.isNew)"
						:expand-on-click="true"
						:image-url="getThumbSrc(image)"
						:expand-url="getMainSrc(image)"
						max-height="120px"
						:value="image"
						:layers-key="image && 'meta' in image ? image.meta.key : 0"
						v-on:editedImg="saveImageEdit($event, image)"
						v-on:rotate="rotateImage($event, image)"
						v-on:deleteImg="removeImage(field, index)">
					</image-panel>

					<upload-field
						v-if="!readonly"
						style="width:100%;height: 40px;margin-top:10px"
						:icons="['fa-plus','fa-camera']"
						accept="documents/images"
						target="UploadImage/save"
						:multiple="true"
						style-type="box"
						v-on:uploaded="imageUploaded($event,field)">		
					</upload-field>
				</template>

				<!--<upload-field-with-panel
					:readonly="readonly"
					api-model="UploadImage"
					upload-type="image"
					v-model="field.value"
					v-on:uploaded="imageUploaded($event,field)">
				</upload-field-with-panel>-->

			</form-group>

		</div>

		<div v-else-if="field.type == 'whiteboard'">

			<form-group :label="field.label" col-class="stacked">

				<image-panel
					v-for="(image, index) in field.value"
					v-if="image"
					:readonly="readonly"
					:no-edit="!image || !('meta' in image && image.meta.isNew)"
					:no-rotate="true"
					max-height="120px"
					:value="image"
					:layers-key="image && 'meta' in image ? image.meta.key : 0"
					v-on:editedImg="saveImageEdit($event, image, false)"
					v-on:deleteImg="removeImage(field, index)">
				</image-panel>

				<button v-if="!readonly" type="button" class="btn btn-light w-100" v-on:click="addCanvas(field)">
					<i class="fa fa-plus"></i>
					Add Whiteboard
				</button>

				<!--<upload-field-with-panel
					:readonly="readonly"
					api-model="UploadImage"
					upload-type="image"
					v-model="field.value"
					v-on:uploaded="imageUploaded($event,field)">
				</upload-field-with-panel>-->

			</form-group>

		</div>

		<div v-else-if="field.type == 'static-paragraph'">
			<h5>{{field.label}}</h5>
			<div v-html="stripInlineEventHandlers(field.default)"></div>
		</div>

		<div v-else-if="field.type == 'table'">

			<field
				class="mb-3"
				:key="field.label"
				:label="field.label"
				:params="setFieldParams(field)"
				:readonly="readonly"
				col-class="stacked"
				v-model="field.value">
			</field>

		</div>

		<div v-else-if="field.type == 'youtube-video'" class="mb-3">
			<label class="col-form-label">{{field.label}}</label>
			<youtube-video :url="field.value"></youtube-video>
		</div>

		<div v-else-if="field.type == 'library-file'">

			<label class="col-form-label mr-5">{{field.label}}</label>

			<button v-if="!readonly" type="button" class="btn btn-light" v-on:click="openLibraryFileModal(field)">
				<i class="fa fa-file"></i>
				Select File
			</button>

			<div v-if="field.value && typeof(field.value) == 'object'" class="mt-2">

				<file-list-item
					:key="field.value.id"
					:id="field.value.id"
					:filename="field.value.original_filename"
					:src="getMainSrc(field.value, 'files')"
					:thumb-src="getThumbSrc(field.value, 'files')"
					:non-editable="true">
				</file-list-item>

			</div>
		</div>

		<field
			v-else-if="
			field.type != 'tasklist' 
			&& 
			(!('positiveResponseRequired' in field) || !field.positiveResponseRequired)
			&& 
			(!('negativeResponseRequired' in field) || !field.negativeResponseRequired)"
			:key="field.label"
			:label="field.label"
			:col-class="setFieldParams(field).type == 'checklist' ? 'stacked' : 'col-md-6'"
			:readonly="readonly"
			:params="setFieldParams(field)"
			v-on:change="emitFields"
			v-model="field.value">
		</field>

		<div v-else-if="field.type == 'tasklist'">

			<h5>{{ field.label }}</h5>

			<div v-for="(item,itemIndex) in field.value" class="task-item">
				<i v-if="!readonly" class="fa fa-times icon-button" v-on:click="removeTask(fieldIndex,itemIndex)"></i>

				<field
					v-show="!field.meta.tasks[itemIndex] || !('customTask' in field.meta.tasks[itemIndex]) || !field.meta.tasks[itemIndex].customTask"
					:key="field.label+Math.random()"
					label="Step/Task"
					col-class="col-3 col-sm-2"
					:readonly="readonly"
					:params="{type:'select',options:taskOptions}"
					v-model="field.value[itemIndex]"
					v-on:change="taskSelected($event,field,itemIndex)">

					<a v-if="!readonly" href="#" v-on:click.prevent="setCustomTask(field,itemIndex,true)">Add custom task...</a>

				</field>

				<field
					v-show="!field.meta.tasks[itemIndex] || 'customTask' in field.meta.tasks[itemIndex] && field.meta.tasks[itemIndex].customTask"
					:key="field.label+Math.random()"
					label="Custom Step/Task"
					col-class="col-4 col-sm-3"
					:readonly="readonly"
					:value="field.value[itemIndex]"
					v-on:change="customTaskSet($event,fieldIndex,itemIndex)">

					<a v-if="!readonly" href="#" v-on:click.prevent="setCustomTask(field,itemIndex,false)">Pick from list...</a>

				</field>

				<div class="row no-gutters">
					<div class="col-12 col-sm-6">

						<table class="table table-sm table-bordered">
							<tr class="table-secondary">
								<th>Hazards</th>
							</tr>
							<tr>
								<td class="list-cell">
									<draggable element="ul" v-if="field && 'meta' in field && 'tasks' in field.meta && field.meta.tasks[itemIndex].hazards" v-model="field.meta.tasks[itemIndex].hazards">
										<li v-for="(hazard,hazardIndex) in field.meta.tasks[itemIndex].hazards" class="hazard-control-list-item">
											{{hazard}}
											<i v-if="!readonly" class="fa fa-trash icon-button" v-on:click="removeHazard(hazardIndex,fieldIndex,itemIndex)"></i>
										</li>
									</draggable>
									<field v-if="!readonly" label="Add Hazard"
										class="add-to-list-select"
										col-class="stacked"
										:params="{type:'select',options:hazardOptions(field.meta.tasks[itemIndex].hazards)}"
										v-on:change="hazardAdded($event,field,itemIndex)">
									</field>
									<form-group v-if="!readonly" label="Custom Hazard"
										class="add-to-list-text"
										col-class="stacked">
										<div class="d-flex flex-row">
											<field style="flex-grow: 1"
												:ref="'hazard_'+itemIndex">
											</field>
											<button type="button" class="btn btn-success" v-on:click="addCustomHazardOrControl('hazard',field,itemIndex)">Add</button>
										</div>
									</form-group>
								</td>
							</tr>
						</table>

					</div>
					<div class="col-12 col-sm-6">
						<table class="table table-sm table-bordered">
							<tr class="table-secondary">
								<th>Controls</th>
							</tr>
							<tr>
								<td class="list-cell">
									<draggable element="ul" v-if="field && 'meta' in field && 'tasks' in field.meta && field.meta.tasks[itemIndex].controls" v-model="field.meta.tasks[itemIndex].controls">
										<li v-for="(control,controlIndex) in field.meta.tasks[itemIndex].controls" class="hazard-control-list-item">
											{{control}}
											<i v-if="!readonly" class="fa fa-trash icon-button" v-on:click="removeControl(controlIndex,fieldIndex,itemIndex)"></i>
										</li>
									</draggable>
									<field v-if="!readonly" label="Add Control"
										class="add-to-list-select"
										col-class="stacked"
										:params="{type:'select',options:controlOptions(field.meta.tasks[itemIndex].controls)}"
										v-on:change="controlAdded($event,field,itemIndex)">
									</field>
									<form-group v-if="!readonly" label="Custom Control"
										class="add-to-list-text"
										col-class="stacked">
										<div class="d-flex flex-row">
											<field style="flex-grow: 1"
												:ref="'control_'+itemIndex">
											</field>
											<button type="button" class="btn btn-success" v-on:click="addCustomHazardOrControl('control',field,itemIndex)">Add</button>
										</div>
									</form-group>
								</td>
							</tr>
						</table>
					</div>
				</div>

				<button v-if="!readonly" v-on:click="copyTask(field,itemIndex)" type="button" class="btn btn-light btn-sm float-right">
					<i class="fa fa-copy"></i>
					Copy to New Task
				</button>
				<div style="clear: both;"></div>
			</div>

			<button v-if="!readonly" v-on:click="addTaskToTaskList(field)" type="button" class="btn btn-success float-right">
				<i class="fa fa-plus"></i>
				Add Task
			</button>

			<div style="clear: both;"></div>

		</div>

		<field
			v-else
			:key="field.label"
			:label="field.label"
			:params="setFieldParams(field)"
			:readonly="readonly"
			col-class="col-md-6"
			v-model="field.value">
		</field>

		<div v-if="field.type == 'select-multi' && 'defineOther' in field && field.defineOther" class="input-group col-md-6 ml-auto pl-5 pr-0 mb-3">
			<input type="text" class="form-control" placeholder="Other option" v-model="field.tempOther" />
			<div class="input-group-append">
				<button type="button" class="btn btn-primary" v-on:click="addOtherOption(field)">Add</button>
			</div>
		</div>

		<field v-if="showConditionalRemarks(field)"
			:label="field.conditionalRemarksLabel"
			col-class="col-md-6"
			:params="{type:'textarea'}"
			v-model="field.conditionalRemarksResponseValue">
		</field>

		<div v-if="showConditionalImageField(field)">

			<form-group :label="field.conditionalImageLabel"
				col-class="col-md-6">

				<image-panel v-for="(image, index) in field.conditionalImageResponseValue"
					:readonly="readonly"
					:no-edit="!image || !('meta' in image && image.meta.isNew)"
					:no-rotate="!image || !('meta' in image && image.meta.isNew)"
					:expand-on-click="true"
					:image-url="getThumbSrc(image)"
					:expand-url="getMainSrc(image)"
					max-height="120px"
					:value="image"
					:layers-key="image && 'meta' in image ? image.meta.key : 0"
					v-on:editedImg="saveImageEdit($event, image)"
					v-on:rotate="rotateImage($event, image)"
					v-on:deleteImg="removeImage(field, index, 'conditionalImage')">
				</image-panel>

				<upload-field
					v-if="!readonly"
					style="width:100%;height: 40px;margin-top:10px"
					:icons="['fa-plus','fa-camera']"
					accept="documents/images"
					target="UploadImage/save"
					:multiple="true"
					style-type="box"
					v-on:uploaded="imageUploaded($event,field,'conditionalImage')">
				</upload-field>

			</form-group>

		</div>

		<library-file-selector-modal
			:visible="libraryFileModal.visible"
			:project="project"
			:service="service"
			v-on:selected="libraryFileSelected"
			v-on:closeModal="libraryFileModal.visible = false">
		</library-file-selector-modal>
	</div>
</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import YoutubeVideo from "@/components/YoutubeVideo"

import UploadFieldWithPanel from "@/components/super_components/UploadFieldWithPanel"
import ImagePanel from "@/components/ImagePanel"
import UploadField from "@/components/UploadField"

import WeatherWidget from "@/components/super_components/WeatherWidget"
import LibraryFileSelectorModal from "@/components/super_components/LibraryFileSelectorModal"
import FileListItem from "@/components/FileListItem"

import FormMixins from "@/mixins/FormMixins"
import FabricMixins from "@/mixins/FabricMixins"
import draggable from 'vuedraggable'

export default {
	name: "FormFillableFields",
	components: {
		Field,
		FormGroup,
		WeatherWidget,
		UploadFieldWithPanel,
		draggable,
		ImagePanel,
		UploadField,
		YoutubeVideo,
		LibraryFileSelectorModal,
		FileListItem
	},
	mixins: [FormMixins, FabricMixins],
	props: ["value","tasks","hazards","controls","readonly","project","service","isChildTemplate"],
	data() {
		return {
			localFormFields: [],

			libraryFileModal: {
				visible: false,
				field: null
			}
		}
	},
	watch: {
		value() {
			this.setLocalFormFields()
		}
	},
	computed: {
		taskOptions() {
			return this.optionify(this.tasks,"description",true)
		},
		job() {
			if (this.project)
				return this.project
			else if (this.service)
				return this.service
			else
				return null
		}
	},
	methods: {
		addOtherOption(field) {
			if ('tempOther' in field && field.tempOther) {
				if (!field.value.includes(field.tempOther.trim()))
					field.value.push(field.tempOther)
				if (!field.options.includes(field.tempOther.trim()))
					field.options.push(field.tempOther)
				field.tempOther = ""
			}
		},
		libraryFileSelected(file) {
			let newFile = {}

			if ('LibraryUpload' in file && file.LibraryUpload) {
				const fieldsToKeep = ['id', 'slug', 'filename', 'original_filename', 'thumb_filename']
				fieldsToKeep.forEach(field => {
					if (field in file.LibraryUpload && file.LibraryUpload[field])
						newFile[field] = file.LibraryUpload[field]
				})
			}

			this.libraryFileModal.field.value = newFile
		},
		openLibraryFileModal(field) {
			this.libraryFileModal.field = field
			this.libraryFileModal.visible = true
		},
		saveImageEdit(newLayer, image, isImage=true) {
			let vm = this
			let payload = {
				layer_json: JSON.stringify(newLayer)
			}

			if (isImage)
				payload.image_id = image.id
			else
				payload.canvas_id = image.id

			this.postData("ImageDrawLayer/save", payload).then(response => {
				if (response.success) {
					image.meta.key += 1
				}
			})

		},

		rotateImage(direction, image) {

			let payload = {
				id: image.id,
				rotate_direction: direction
			}

			this.postData("UploadImage/rotate", payload).then(response => {
				if (response.success) {
					let name = image.filename.split("?")[0]
					image.filename = name + "?" + Math.random()
					image.meta.key += 1
				}
			})

		},
		removeImage(field, index, type="") {
			// We do not fully delete images -- just dereference
			// This is because if this image is a placeholder in a template or copied over from another
			// form, then deleted, then the original template/form will no longer have the original image
			if (type == 'conditionalImage')
				field.conditionalImageResponseValue.splice(index, 1)
			else
				field.value.splice(index, 1)

			this.emitFields()
		},
		weatherFetched(responseData,fieldIndex) {
			this.localFormFields[fieldIndex].value = responseData
		},
		cleanOrphanedTasks(fieldIndexOrField) {
			if (typeof fieldIndexOrField == 'number') {
				//apparently tasks in .meta.tasks haven't been kept in sync with the tasks listed in .value. This method will check for old tasks and wipe them out

				let length = this.localFormFields[fieldIndexOrField].value.length

				if (this.localFormFields[fieldIndexOrField].meta.tasks.length > length)
					this.localFormFields[fieldIndexOrField].meta.tasks.splice(length)
			}
			else {
				let length = fieldIndexOrField.value.length

				if (fieldIndexOrField.meta.tasks.length > length)
					fieldIndexOrField.meta.tasks.splice(length)
			}
		},
		setFieldParams(field) {
			let vm = this

			if (field.type == "hazard-list") {
				this.$emit("fetchHazards")

				return {
					type: 'checklist',
					options: this.hazardOptions
				}
			}
			else if (field.type == "control-list") {
				this.$emit("fetchControls")

				return {
					type: 'checklist',
					options: this.controlOptions
				}
			}
			else if (field.type == 'personnel-phone-list') {
				let phoneListOptions = []

				let job

				if (this.project)
					job = this.project
				else if (this.service)
					job = this.service

				if (job && "User" in job) {
					phoneListOptions = vm.optionify(job.User.map(user => {
						user.displayField = user.first_name+" "+user.last_name

						if (user.phone_mobile)
							user.displayField += ": "+user.phone_mobile

						return user
					}),"displayField")

					if ("defineOther" in field && field.defineOther)
						phoneListOptions.push({value:"Other",text:"Other"})
				}
				else {
					phoneListOptions = [
						{value: 'Other', text: 'Other'}
					]
				}

				return {
					type: 'select',
					options: phoneListOptions
				}
			}
			else if (field.type == 'boolean') {
				let buttons = [
					{text: "Yes",value: 1, icon: 'fa-check'},
					{text: "No", value: 0, icon: 'fa-times'}
				]
				if (field.buttonLanguage === 'fr') {
					buttons = [
						{text: "Oui",value: 1, icon: 'fa-check'},
						{text: "Non", value: 0, icon: 'fa-times'}
					]
				}
				return {
					type: 'btn-group',
					buttons
				}
			}
			else if (field.type == 'table') {
				return {
					type: 'table',
					rows: field.rows,
					columns: field.columns
				}
			}
			else {
				let ret = {
					type: field.type
				}

				if ("options" in field) {
					ret.options = field.options.map(opt => {
						return {text:opt,value:opt}
					})

					if ("defineOther" in field && field.defineOther && field.type == 'select')
						ret.options.push({value:"Other",text:"Other"})
				}

				return ret
			}
		},
		setLocalFormFields() {
			this.localFormFields = this.value

			this.localFormFields.forEach((field,index) => {
				if (field.type == 'tasklist' && !("meta" in field)) {
					field.meta = {
						tasks: []
					}
				}
				if (field.value === '' && field.type != 'select')
					field.value = null
			})
		},
		addTaskToTaskList(field) {
			let vm = this

			vm.cleanOrphanedTasks(field)

			field.value.push("")

			if (!("meta" in field)) {
				field.meta = {
					tasks: [{
						hazards: [],
						controls: []
					}]
				}	
			}
			else {
				field.meta.tasks.push({
					hazards: [],
					controls: []
				})
			}

			this.$nextTick(() => {
				vm.emitFields()
			})
		},
		copyTask(field,itemIndex) {
			let vm = this

			vm.cleanOrphanedTasks(field)

			let item = field.value[itemIndex]

			field.value.push(field.value[itemIndex])
			field.meta.tasks.push(vm.cloneObj(field.meta.tasks[itemIndex]))

			this.$nextTick(() => {
				vm.emitFields()
			})
		},
		taskSelected(theTask,field,itemIndex) {
			let vm = this

			//task selected, we need to build the default hazards/controls lists
			let hazardList = vm.tasks.find(task => theTask == task.description)
			let controlList = vm.tasks.find(task => theTask == task.description)

			if (hazardList)
				hazardList = hazardList.SafetyHazard.map(item => item.description)
			else
				hazardList = []

			if (controlList)
				controlList = controlList.SafetyControl.map(item => item.description)
			else
				controlList = []

			field.meta.tasks[itemIndex].hazards = hazardList
			field.meta.tasks[itemIndex].controls = controlList

			this.emitFields()
		},
		setCustomTask(field,itemIndex,state){
			this.$set(field.meta.tasks[itemIndex],'customTask',state)

			this.emitFields()
		},
		customTaskSet(theTask,fieldIndex,itemIndex) {
			let vm = this

			if (this.localFormFields[fieldIndex].value.length <= fieldIndex)
				this.localFormFields[fieldIndex].value.push(theTask)

			else
				this.localFormFields[fieldIndex].value[itemIndex] = theTask

			//this.localFormSections[sectionIndex].fields[fieldIndex].value[itemIndex] = theTask

			this.emitFields()
		},
		hazardAdded(item,field,itemIndex) {

			//check that it does not exist already
			if (!field.meta.tasks[itemIndex].hazards.find(haz => haz == item))
				field.meta.tasks[itemIndex].hazards.push(item)

			this.emitFields()
		},
		controlAdded(item,field,itemIndex) {
			if (!field.meta.tasks[itemIndex].hazards.find(con => con == item))
				field.meta.tasks[itemIndex].controls.push(item)

			this.emitFields()
		},
		addCustomHazardOrControl(type,field,itemIndex) {
			//get element directly by ref so clear the value
			let input = this.$refs[type+'_'+itemIndex][0].$children[0].$slots.default[0].children[0].elm
			if (input) {
				field.meta.tasks[itemIndex][type+'s'].push(input.value)
				input.value = ""
			}
			this.emitFields()
		},
		removeTask(fieldIndex,itemIndex) {
			this.cleanOrphanedTasks(fieldIndex)

			this.localFormFields[fieldIndex].value.splice(itemIndex,1)
			this.localFormFields[fieldIndex].meta.tasks.splice(itemIndex,1)

			this.emitFields()
		},
		removeHazard(index,fieldIndex,itemIndex) {
			this.localFormFields[fieldIndex].meta.tasks[itemIndex].hazards.splice(index,1)
			this.emitFields()
		},
		removeControl(index,fieldIndex,itemIndex) {
			this.localFormFields[fieldIndex].meta.tasks[itemIndex].controls.splice(index,1)
			this.emitFields()
		},
		addCanvas(field) {
			let vm = this

			let payload = {
				width: this.CANVAS_DEFAULTS.width,
				height: this.CANVAS_DEFAULTS.height
			}
			this.postData("DrawCanvas/save", payload).then(response => {

				if (response.success) {

					if (!field.value)
						field.value = []

					field.value.push({
						id: response.record_id,
						slug: response.slug,
						width: vm.CANVAS_DEFAULTS.width,
						height: vm.CANVAS_DEFAULTS.height,
						meta: {
							isNew: true,
							key: 0
						},

					})

					vm.emitFields()

				}

			})
		},
		imageUploaded(response,field,type) {
			let img = response.data

			img.meta = {
				isNew: true,
				key: 0
			}

			if (type == 'conditionalImage') {
				if (!field.conditionalImageResponseValue)
					field.conditionalImageResponseValue = []

				field.conditionalImageResponseValue.push(img)
			}
			
			else {
				if (!field.value)
					field.value = []

				field.value.push(img)
			}

			let vm = this

			let payload = {
				id: img.id,
				do_not_clean: 1
			}

			this.postData("UploadImage/update",payload).then(response => {
				vm.emitFields()
			})
		},
		emitFields() {
			this.$forceUpdate()
			this.$emit("input", this.localFormFields)
		}
	},
	created() {
		this.setLocalFormFields()
	}
}

</script>

<style type="text/css" scoped>

.task-item {
	position: relative;
	border: 1px solid #e0e0e0;
	padding: 5px;
	padding-top: 35px;
	margin-bottom: 10px;
}

.task-item .icon-button {
	position: absolute;
	top: 5px;
	right: 5px;
}

.list-cell {
	position: relative;
	padding-bottom: 140px;
}

.add-to-list-select {
	width: calc(100% - 10px);
	position: absolute;
	bottom: 70px;
}

.add-to-list-text {
	width: calc(100% - 10px);
	position: absolute;
	bottom: 0;
}

.hazard-control-list-item {
	position: relative;
	cursor: pointer;
}

.hazard-control-list-item .fa-trash {
	position: absolute;
	right: 0;
	display: none;
}

.hazard-control-list-item:hover .fa-trash {
	display: inline;
}

.company-form-field.error {
	border: 1px solid red;
	position: relative;
	z-index: 10;
}

</style>